<template>
  <!-- Skeleton for patient information form -->
  <v-card class="mb-6 submission-detail-section">
    <v-card-title>
      <v-skeleton-loader type="heading" width="60%"></v-skeleton-loader>
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col v-for="i in 4" :key="`patient-${i}`" cols="12" md="6">
          <v-skeleton-loader type="list-item-avatar-two-line" class="mb-4"></v-skeleton-loader>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>

  <!-- Skeleton for pharmacy information -->
  <v-card class="mb-6 submission-detail-section">
    <v-card-title>
      <v-skeleton-loader type="heading" width="40%"></v-skeleton-loader>
    </v-card-title>
    <v-card-text>
      <v-skeleton-loader type="paragraph" class="mb-4"></v-skeleton-loader>
      <v-skeleton-loader type="list-item-three-line"></v-skeleton-loader>
    </v-card-text>
  </v-card>

  <!-- Skeleton for diagnosis information -->
  <v-card class="mb-6 submission-detail-section">
    <v-card-title>
      <v-skeleton-loader type="heading" width="50%"></v-skeleton-loader>
    </v-card-title>
    <v-card-text>
      <v-skeleton-loader type="heading" width="30%" class="mb-4"></v-skeleton-loader>
      <v-skeleton-loader type="list-item-three-line"></v-skeleton-loader>
      <v-skeleton-loader type="list-item-two-line" class="mt-4"></v-skeleton-loader>
    </v-card-text>
  </v-card>

  <!-- Skeleton for step therapies -->
  <v-card class="mb-6 submission-detail-section">
    <v-card-title>
      <v-skeleton-loader type="heading" width="45%"></v-skeleton-loader>
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col v-for="i in 2" :key="`therapy-${i}`" cols="12" md="6">
          <v-skeleton-loader type="list-item-avatar-three-line" class="mb-4"></v-skeleton-loader>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>

  <!-- Skeleton for supporting documents -->
  <v-card class="mb-6 submission-detail-section">
    <v-card-title>
      <v-skeleton-loader type="heading" width="55%"></v-skeleton-loader>
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col v-for="i in 3" :key="`doc-${i}`" cols="12">
          <v-skeleton-loader type="list-item-avatar-two-line" class="mb-4"></v-skeleton-loader>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>

  <!-- Skeleton for questions -->
  <v-card class="mb-6 submission-detail-section">
    <v-card-title>
      <v-skeleton-loader type="heading" width="35%"></v-skeleton-loader>
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col v-for="i in 4" :key="`question-${i}`" cols="12">
          <v-skeleton-loader type="list-item-three-line" class="mb-4"></v-skeleton-loader>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
